import type { Resource } from '../../';
export const general_closeNotification: Resource = {"default":"Close Notification"};
